import { badgeContent, styles } from "../utils/tour.js";
import "react";
import { jsx } from "react/jsx-runtime";
import { TourProvider } from "@reactour/tour";
//#region src/modules/core/providers/tour.tsx
var PortalTour = ({ children, steps = [], ...rest }) => /* @__PURE__ */ jsx(TourProvider, {
	...rest,
	steps,
	badgeContent,
	disableDotsNavigation: true,
	showDots: false,
	styles,
	children
});
//#endregion
export { PortalTour };
